import { observer } from "mobx-react-lite"
import { FC, useContext, useEffect, useState } from "react"
import { Context } from ".."

import styles from "../styles/Home.module.scss"

const NotFoundPage: FC = () => {

  const { store } = useContext(Context)

  const [anim1, setAnim1] = useState(false)

  useEffect(() => {
    window.scrollTo({ behavior: "smooth", top: 0 })

    setTimeout(() => {
      setAnim1(prev => prev = true)
    }, 500)

  }, [])

  return (
    <>
      <div className={styles.section_top} style={{
        opacity: anim1 ? "1" : "0"
      }}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className={styles.not_found}>
                <h1>404</h1>
                <p>
                  Вы перешли на страницу, которой не существует :(<br/><br/>
                  <a href={store.prevLastRoute}>Вернуться назад</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default observer(NotFoundPage)